import { useRef } from 'react'
import { cn } from '@/lib/utils'
import { formatCurrency, formatNumber } from '@/lib/format'
import { useInView } from '@/hooks/use-in-view'
import { useTween } from '@/hooks/use-tween'

interface CountUpProps {
    value: number
    decimals?: number
    prefix?: string
    suffix?: string
    duration?: number
    delay?: number
    format?: 'currency' | 'number'
    active?: boolean
    from?: number
    className?: string
}

/** A number that counts up to its value when it scrolls into view. */
export const CountUp = ({
    value,
    decimals = 0,
    prefix = '',
    suffix = '',
    duration = 1600,
    delay = 0,
    format = 'number',
    active,
    from = 0,
    className
}: CountUpProps) => {
    const ref = useRef<HTMLSpanElement>(null)
    const inView = useInView(ref)
    const current = useTween(value, { active: active ?? inView, duration, delay, from })
    const render = (amount: number) => format === 'currency' ? formatCurrency(amount, { decimals }) : formatNumber(amount, decimals)

    return (
        <span ref={ref} className={cn('tabular-nums', className)}>
            <span aria-hidden='true'>
                {prefix}{render(current)}{suffix}
            </span>

            <span className='sr-only'>
                {prefix}{render(value)}{suffix}
            </span>
        </span>
    )
}
